<app-modal #modalConfirmCancel [modalConfig]="modalConfig">
  <div class="d-flex justify-content-center align-items-center text-center mt-8">
    <p>Apakah anda yakin keluar dari halaman Generate Batch QR? Data yang diinput akan hilang.</p>
  </div>
</app-modal>
